export function formatDescription(description: string, numberOfLines: number) {
  if (numberOfLines === 1) {
    return description.length > 38
      ? `${description.slice(0, 38)}...`
      : description
  }

  const firstLine = description.slice(0, 38)

  const lastSpaceIndex = firstLine.lastIndexOf(' ')
  const firstLineAdjusted =
    lastSpaceIndex !== -1 ? firstLine.slice(0, lastSpaceIndex) : firstLine

  const secondLine = description.slice(firstLineAdjusted.length).trim()

  return `${firstLineAdjusted}\n${secondLine.length > 35 ? `${secondLine.slice(0, 35)}...` : secondLine}`
}
